const defaultFileTypes = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "application/pdf": [".pdf"],
};

const extraFileTypesByKey = {
  excel: {
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  },
};

export const getAcceptedFileTypes = (extraTypeDataKeys = []) => {
  const acceptedFileTypes = { ...defaultFileTypes };

  for (const key of extraTypeDataKeys ?? []) {
    if (Object.hasOwn(extraFileTypesByKey, key)) {
      Object.assign(acceptedFileTypes, extraFileTypesByKey[key]);
    }
  }

  return acceptedFileTypes;
};
